/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AttentionRouteImport } from './routes/attention'
import { Route as CheckinRouteImport } from './routes/checkin'
import { Route as ConnectionRouteImport } from './routes/connection'
import { Route as ExportRouteImport } from './routes/export'
import { Route as MoreRouteImport } from './routes/more'
import { Route as NotesRouteImport } from './routes/notes'
import { Route as PhotosRouteImport } from './routes/photos'
import { Route as ReactionRouteImport } from './routes/reaction'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SpfRouteImport } from './routes/spf'
import { Route as WeekRouteImport } from './routes/week'
import { Route as HistoryIndexRouteImport } from './routes/history/index'
import { Route as HistoryDateRouteImport } from './routes/history/$date'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductsIdRouteImport } from './routes/products/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AttentionRoute = AttentionRouteImport.update({
  id: '/attention',
  path: '/attention',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckinRoute = CheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionRoute = ConnectionRouteImport.update({
  id: '/connection',
  path: '/connection',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreRoute = MoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesRoute = NotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => rootRouteImport,
} as any)
const PhotosRoute = PhotosRouteImport.update({
  id: '/photos',
  path: '/photos',
  getParentRoute: () => rootRouteImport,
} as any)
const ReactionRoute = ReactionRouteImport.update({
  id: '/reaction',
  path: '/reaction',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SpfRoute = SpfRouteImport.update({
  id: '/spf',
  path: '/spf',
  getParentRoute: () => rootRouteImport,
} as any)
const WeekRoute = WeekRouteImport.update({
  id: '/week',
  path: '/week',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIndexRoute = HistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryDateRoute = HistoryDateRouteImport.update({
  id: '/history/$date',
  path: '/history/$date',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIdRoute = ProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/attention': typeof AttentionRoute
  '/checkin': typeof CheckinRoute
  '/connection': typeof ConnectionRoute
  '/export': typeof ExportRoute
  '/more': typeof MoreRoute
  '/notes': typeof NotesRoute
  '/photos': typeof PhotosRoute
  '/reaction': typeof ReactionRoute
  '/settings': typeof SettingsRoute
  '/spf': typeof SpfRoute
  '/week': typeof WeekRoute
  '/history/$date': typeof HistoryDateRoute
  '/products/$id': typeof ProductsIdRoute
  '/history/': typeof HistoryIndexRoute
  '/products/': typeof ProductsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/attention': typeof AttentionRoute
  '/checkin': typeof CheckinRoute
  '/connection': typeof ConnectionRoute
  '/export': typeof ExportRoute
  '/more': typeof MoreRoute
  '/notes': typeof NotesRoute
  '/photos': typeof PhotosRoute
  '/reaction': typeof ReactionRoute
  '/settings': typeof SettingsRoute
  '/spf': typeof SpfRoute
  '/week': typeof WeekRoute
  '/history/$date': typeof HistoryDateRoute
  '/products/$id': typeof ProductsIdRoute
  '/history': typeof HistoryIndexRoute
  '/products': typeof ProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/attention': typeof AttentionRoute
  '/checkin': typeof CheckinRoute
  '/connection': typeof ConnectionRoute
  '/export': typeof ExportRoute
  '/more': typeof MoreRoute
  '/notes': typeof NotesRoute
  '/photos': typeof PhotosRoute
  '/reaction': typeof ReactionRoute
  '/settings': typeof SettingsRoute
  '/spf': typeof SpfRoute
  '/week': typeof WeekRoute
  '/history/$date': typeof HistoryDateRoute
  '/products/$id': typeof ProductsIdRoute
  '/history/': typeof HistoryIndexRoute
  '/products/': typeof ProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/attention'
    | '/checkin'
    | '/connection'
    | '/export'
    | '/more'
    | '/notes'
    | '/photos'
    | '/reaction'
    | '/settings'
    | '/spf'
    | '/week'
    | '/history/$date'
    | '/products/$id'
    | '/history/'
    | '/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/attention'
    | '/checkin'
    | '/connection'
    | '/export'
    | '/more'
    | '/notes'
    | '/photos'
    | '/reaction'
    | '/settings'
    | '/spf'
    | '/week'
    | '/history/$date'
    | '/products/$id'
    | '/history'
    | '/products'
  id:
    | '__root__'
    | '/'
    | '/attention'
    | '/checkin'
    | '/connection'
    | '/export'
    | '/more'
    | '/notes'
    | '/photos'
    | '/reaction'
    | '/settings'
    | '/spf'
    | '/week'
    | '/history/$date'
    | '/products/$id'
    | '/history/'
    | '/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AttentionRoute: typeof AttentionRoute
  CheckinRoute: typeof CheckinRoute
  ConnectionRoute: typeof ConnectionRoute
  ExportRoute: typeof ExportRoute
  MoreRoute: typeof MoreRoute
  NotesRoute: typeof NotesRoute
  PhotosRoute: typeof PhotosRoute
  ReactionRoute: typeof ReactionRoute
  SettingsRoute: typeof SettingsRoute
  SpfRoute: typeof SpfRoute
  WeekRoute: typeof WeekRoute
  HistoryDateRoute: typeof HistoryDateRoute
  ProductsIdRoute: typeof ProductsIdRoute
  HistoryIndexRoute: typeof HistoryIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attention': {
      id: '/attention'
      path: '/attention'
      fullPath: '/attention'
      preLoaderRoute: typeof AttentionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkin': {
      id: '/checkin'
      path: '/checkin'
      fullPath: '/checkin'
      preLoaderRoute: typeof CheckinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connection': {
      id: '/connection'
      path: '/connection'
      fullPath: '/connection'
      preLoaderRoute: typeof ConnectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more': {
      id: '/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof MoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes': {
      id: '/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof NotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/photos': {
      id: '/photos'
      path: '/photos'
      fullPath: '/photos'
      preLoaderRoute: typeof PhotosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reaction': {
      id: '/reaction'
      path: '/reaction'
      fullPath: '/reaction'
      preLoaderRoute: typeof ReactionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spf': {
      id: '/spf'
      path: '/spf'
      fullPath: '/spf'
      preLoaderRoute: typeof SpfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/week': {
      id: '/week'
      path: '/week'
      fullPath: '/week'
      preLoaderRoute: typeof WeekRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/': {
      id: '/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof HistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$date': {
      id: '/history/$date'
      path: '/history/$date'
      fullPath: '/history/$date'
      preLoaderRoute: typeof HistoryDateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$id': {
      id: '/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AttentionRoute: AttentionRoute,
  CheckinRoute: CheckinRoute,
  ConnectionRoute: ConnectionRoute,
  ExportRoute: ExportRoute,
  MoreRoute: MoreRoute,
  NotesRoute: NotesRoute,
  PhotosRoute: PhotosRoute,
  ReactionRoute: ReactionRoute,
  SettingsRoute: SettingsRoute,
  SpfRoute: SpfRoute,
  WeekRoute: WeekRoute,
  HistoryDateRoute: HistoryDateRoute,
  ProductsIdRoute: ProductsIdRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
